import BaseModel from '@/models/BaseModel.js'

export default class Repair extends BaseModel {
  fields = {
    tanggal_perbaikan: {
      label: 'Tanggal perbaikan',
      type: 'date',
      rules: 'required'
    },
    nama_barang: {
      label: 'Nama barang',
      type: 'text',
      rules: 'required'
    },
    deskripsi_kerusakan: {
      label: 'Deskripsi kerusakan',
      type: 'textarea',
      rules: 'required'
    },
    kadar: {
      label: 'Kadar',
      type: 'text',
      rules: 'required'
    },
    berat: {
      label: 'Berat (gram)',
      type: 'number',
      rules: 'required'
    },
    biaya_perbaikan: {
      label: 'Biaya perbaikan',
      type: 'price',
      rules: 'required'
    }
  }

  endpoint = process.env.VUE_APP_API_URL + 'repairs'
}
